/**
 * TanStack Query hooks for `igaming-revshare`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingRevshareQueryKeys,
	type CreateIgamingRevshareBody,
	type ListIgamingRevshareResponse,
	type IgamingRevshareRow,
} from "./api";

export function useIgamingRevshareList(): UseQueryResult<ListIgamingRevshareResponse, Error> {
	return useQuery({
		queryKey: igamingRevshareQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingRevshareCreate(): UseMutationResult<IgamingRevshareRow, Error, CreateIgamingRevshareBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRevshareQueryKeys.all });
		},
	});
}

export function useIgamingRevshareDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRevshareQueryKeys.all });
		},
	});
}
